import React, { createContext } from 'react'

type IContext = {
    trips?: any[]
    mapRef?: any
    vehicles?: any[]
    vehiclesSearched?: any[]
    vehiclesStatusActive?: any[]
    mapInstance?: any
    hardwareData?: any[]
    tripActive?: any
    vehicleActive?: any
    centerMap?: any
    onLoadMap?: any
    setVehicles?: any
    filterActive?: any
    setFilterActive?: any
    isNavegateToTrips?: any
    reverseGeocoding: any
    markersRef?: any
    appointmentsMap?: any
    itinerariesMap?: any
    infoWindow?: any
    tripHoverActisve?: any
    markerHashMap: MarkerHashMap
    poiMarkerHashMap: PoiMarkerHashMap
    isTimeToUpdate: boolean
    isFirstLoad: boolean
    selectedVehicles: MappedMarker[]
    viewSettings?:any
    currentVehicleActive?: any
    setSelectedVehicles(mappedMarker: MappedMarker): void
    setTripHoverActive?(trip): any
    setMarkersRef?(value): any
    setReverseGeocoding?(value): any
    setIsNavegateToTrips?(value): any
    setCurrentVehicleActive?(vehicle): any
    setVehicleActive?(vehicles): any
    setMapInstance?(map): any
    setCenterMap?(center): any
    setTrips?(trips): any
    setVehiclesSearched?(vehicles): any
    setVehiclesStatusActive?(vehicles): any
    setInfoWindow?(infoWindow): any
    setTripActive?(trip): any
    setViewSettings?(settings):any
}

const TripsContext = createContext<IContext>({})
export default TripsContext
